import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/components/HomePage.vue'),
    meta: { title: '个人语言助理' }
  },
  {
    path: '/vocabulary',
    name: 'Vocabulary',
    component: () => import('@/components/VocabularyList.vue'),
    meta: { title: '生词本' }
  },
  {
    path: '/review',
    name: 'Review',
    component: () => import('@/components/VocabularyReview.vue'),
    meta: { title: '生词复习' }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/components/TranslationHistory.vue'),
    meta: { title: '翻译历史' }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/components/SettingsPage.vue'),
    meta: { title: '设置' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫 - 更新页面标题
router.beforeEach((to) => {
  document.title = (to.meta.title as string) || '个人语言助理'
})

export default router
